/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Score_Legend_Summary_RtpInputs */



/**
* | output |
* | --- |
* | "What do GW / VP / TP / RtP mean?" |
*
* @param {Score_Legend_Summary_RtpInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const score_legend_summary_rtp = /** @type {((inputs?: Score_Legend_Summary_RtpInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Score_Legend_Summary_RtpInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Que signifient GW / VP / TP / RtP ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Qué significan GW / VP / TP / RtP?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("O que significam GW / VP / TP / RtP?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cosa significano GW / VP / TP / RtP?")
	return /** @type {LocalizedString} */ ("What do GW / VP / TP / RtP mean?")
});